import type { ReactNode } from 'react';
import { useEmailVerificationGate } from '@/hooks/useEmailVerificationGate';
import { Box, Button, Flex, Text } from '@/ui';

type Props = {
  children: ReactNode;
};

export const EmailVerificationOverlay = ({ children }: Props) => {
  const {
    isEmailVerified,
    isPending,
    cooloffEndTime,
    timeRemaining,
    handleResendClick,
    formatTime,
  } = useEmailVerificationGate();

  return (
    <Box minH="300px" position="relative">
      {isEmailVerified && children}

      {!isEmailVerified && (
        <Box
          backdropFilter="blur(4px)"
          bg="rgba(255, 255, 255, 0.9)"
          borderRadius="md"
          inset="0"
          position="absolute"
        >
          <Flex
            align="center"
            direction="column"
            gap="2"
            h="100%"
            justify="center"
            px="4"
            textAlign="center"
          >
            {cooloffEndTime && timeRemaining > 0 ? (
              <>
                <Text color="gray.800" fontWeight="medium">
                  Email sent! Check your inbox for a verification link. Once
                  verified, come back here to share.
                </Text>
                <Text fontSize="sm" fontWeight="medium">
                  Resend email in {formatTime(timeRemaining)}
                </Text>
              </>
            ) : (
              <>
                <Text color="gray.800" fontWeight="medium">
                  To share this page, please verify your email address. Check
                  your inbox for a verification link, or we can send a new one.
                </Text>
                <Button
                  fontSize="sm"
                  fontWeight="medium"
                  isDisabled={isPending}
                  variant="link"
                  onClick={handleResendClick}
                >
                  Resend verification email
                </Button>
              </>
            )}
          </Flex>
        </Box>
      )}
    </Box>
  );
};
